const DEFAULTS = {
  music: [
    { value: '0', label: '学生乐声' },
    { value: '1', label: '教学乐声' },
    { value: '2', label: '音调音阶' }
  ],
  picture: [
    { value: '0', label: '教学' },
    { value: '1', label: '团建' },
    { value: '2', label: '荣誉' },
    { value: '3', label: '合作' },
    { value: '4', label: '文件' }
  ],
  member: [
    { value: '队员', label: '队员' },
    { value: '学生', label: '学生' }
  ],
  memberTeam: [
    { value: '音愈童心', label: '音愈童心' }
  ]
}

function normalizeList (list, fallback) {
  if (!Array.isArray(list) || !list.length) return fallback.slice()
  return list
    .map(item => ({
      value: String(item.value),
      label: String(item.label || item.value)
    }))
    .filter(item => item.value !== '' && item.label !== '')
}

const category = {
  namespaced: true,
  state: {
    loaded: false,
    music: DEFAULTS.music.slice(),
    picture: DEFAULTS.picture.slice(),
    member: DEFAULTS.member.slice(),
    memberTeam: DEFAULTS.memberTeam.slice()
  },
  mutations: {
    setCategories (state, payload = {}) {
      state.music = normalizeList(payload.music, DEFAULTS.music)
      state.picture = normalizeList(payload.picture, DEFAULTS.picture)
      state.member = normalizeList(payload.member, DEFAULTS.member)
      state.memberTeam = normalizeList(payload.memberTeam, DEFAULTS.memberTeam)
      state.loaded = true
    }
  },
  actions: {
    loadCategories ({ commit, state }, http) {
      if (state.loaded || !http || !http.adornUrl) {
        return Promise.resolve(state)
      }
      return http({
        url: http.adornUrl('/app/dict/types'),
        method: 'get',
        params: http.adornParams({}, false)
      }).then(({ data }) => {
        if (data && (data.code === 0 || data.code === 200) && data.data) {
          commit('setCategories', data.data)
        } else {
          commit('setCategories', DEFAULTS)
        }
      }).catch(() => {
        commit('setCategories', DEFAULTS)
      })
    }
  }
}

export default category
